import React from 'react';
import clsx from 'clsx';
import * as blocLiensStyles from '../../../styles/admissions/admissions.module.scss';
import { PropTypes } from 'prop-types';

const CustomInfos = ({ title, color, comps}) => {
  return (
    <>
      <div
        className={clsx(
          blocLiensStyles.rootTitleThumbnail, {
            [blocLiensStyles.darkBlocLiensEntete]: color === 'BLACK',
            [blocLiensStyles.redBlocLiensEntete]: color !== 'BLACK'})
        }
      >
        <div className={blocLiensStyles.titleItemThumbnail}>
          <h2 className={blocLiensStyles.titleThumbnail}>
            {title}
          </h2>
        </div>
      </div>
      <div
        className={clsx(
          blocLiensStyles.rootContentThumbnail, {
            [blocLiensStyles.darkBlocLiensCorps]: color === 'BLACK',
            [blocLiensStyles.redBlocLiensCorps]: color !== 'BLACK'})
        }
      >
        <div className={blocLiensStyles.contentThumbnail}>
          {comps}
        </div>
      </div>
    </>
  );
};

CustomInfos.propTypes = {
  color: PropTypes.string,
  comps: PropTypes.object,
  title: PropTypes.string,
};

export default CustomInfos;
